export * from './delete-gutachten.service';
export * from './delete-gutachten.service.module';